import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { SVGComponent } from "@typings/svg-component";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";
import { WordingKey } from "@typings/i18n-typings";

interface BottomMobileMenuTabProps {
	context: { index: number; selectedTabIndex: number };
	label: WordingKey;
	icon: SVGComponent;
	iconSelected: SVGComponent;
}
export const BottomMobileMenuTab: React.FC<BottomMobileMenuTabProps> = ({
	context,
	label,
	icon,
	iconSelected,
}) => {
	const { format } = useI18n();
	const isItemSelected = context.index === context.selectedTabIndex;
	const Icon = isItemSelected ? iconSelected : icon;
	const itemColor = isItemSelected ? colors.primaryDark : colors.grey80;
	return (
		<>
			<IconContainer>
				<Icon height={32} width={32} color={itemColor} />
			</IconContainer>
			<MenuItemLabel className="p-size-xs-extra-bold" color={itemColor}>
				{format(label, undefined)}
			</MenuItemLabel>
		</>
	);
};

const IconContainer = styled.div`
	${stack()};
	position: relative;
`;

const MenuItemLabel = styled.span<{ color: string }>`
	color: ${props => props.color};
`;
